import { useEffect, useState } from "react";
import { _CountriesVdos } from "../../../../core/services/dataBean/EntityCatalogVdos"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { StatesView } from "./StatesView";
import { SelectSiteID } from "../SiteID/SelectSiteID";
import { PrintJson } from "../../../theme/Component/PrintJson";

export const SelectCountries = () => {

    const _countries = useDataBean(_CountriesVdos);
    const { bean, setBean, getLista, lista, instance } = _countries;

    const [mainCountry, setMainCountry] = useState<any>({});

    useEffect(() => {
        instance.getDefaultCountry().then(
            (resp: any) => {
                console.log(resp);
                setMainCountry(resp);
            }
        )
    }, [])

    function unicodeToEmoji(code: string) {
        if (!code) return '';
        try {
            return code
                .split(' ')
                .filter(c => c.trim().length > 0)
                .map(c => String.fromCodePoint(parseInt(c.replace('U+', '').trim(), 16)))
                .join('');
        } catch (e) {
            console.error("Error converting unicode to emoji:", e);
            return '';
        }
    }

    // Checking both common casings for the emoji property
    const emojiCode = mainCountry.EmojiU || mainCountry.Emojiu || mainCountry.emoji;
    const emoji = unicodeToEmoji(emojiCode);

    return (
        <div className="row">
            {/* <div className="col-md-12">
                <PrintJson json={mainCountry} />
            </div> */}
            <div className="col-md-12">
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                    {/* <span style={{ fontSize: '2rem' }}>{emoji}</span> */}
                    <h4 style={{ margin: 0 }}>{mainCountry.Name}</h4>
                </div>
            </div>
            {/* <div className="col-md-12">
                <SelectSiteID edit={false} onChange={(e) => { console.log(e) }} />
            </div> */}
            <div className="col-md-12">
                <StatesView idCountry={mainCountry.IDCountries} />
            </div>
        </div>
    )
}